/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createDiscountCodeFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeDiscountCode, serializeDiscountCodeOptionsInput, type DiscountCode, type DiscountCodeOptionsInput, type ErrorResponse, type InternalErrorResponse } from '../../../../../models/index.js';
// @ts-ignore
import { ActiveRequestBuilderRequestsMetadata, type ActiveRequestBuilder } from './active/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/campaigns/{campaignId}/codes/{discountCodeId}
 */
export interface WithDiscountCodeItemRequestBuilder extends BaseRequestBuilder<WithDiscountCodeItemRequestBuilder> {
    /**
     * The active property
     */
    get active(): ActiveRequestBuilder;
    /**
     * Replaces the code's caps, customer list and window. The code text is identity and never changes; the use count is server-managed and untouched.
     * @param body The restrictions a discount code carries on top of its campaign's (D10). Null means none.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<DiscountCode>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     put(body: DiscountCodeOptionsInput, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<DiscountCode | undefined>;
    /**
     * Replaces the code's caps, customer list and window. The code text is identity and never changes; the use count is server-managed and untouched.
     * @param body The restrictions a discount code carries on top of its campaign's (D10). Null means none.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: DiscountCodeOptionsInput, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const WithDiscountCodeItemRequestBuilderUriTemplate = "{+baseurl}/api/campaigns/{campaignId}/codes/{discountCodeId}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithDiscountCodeItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithDiscountCodeItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    active: {
        requestsMetadata: ActiveRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const WithDiscountCodeItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    put: {
        uriTemplate: WithDiscountCodeItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createDiscountCodeFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeDiscountCodeOptionsInput,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
